import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/ComboBox.css';
//import FX from './functions/functions';
class ComboBox extends Component {
  constructor(props) {
    super(props);
    this.value = this.props.defaultValue;
    var value = this.props.defaultValue ? this.props.defaultValue : '';
    this.state = { show: false, value: value };
  }

  handle = (e) => {
    this.setState({value:e.target.value});
    if(typeof this.props.handle === 'function'){
        this.props.handle(e);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log('___________________');
    console.log(prevProps);
    console.log(prevState);
    if(prevProps.id !== this.props.id || prevProps.product_id !== this.props.product_id){
      this.setState({value:''});
    }
    var options = [];
    if(this.props.options){
      options = [];
      this.props.options.forEach(opt => {
          if(options.indexOf(opt.name) === -1){
            options.push(opt.name);
          }
      });
    }
    this.value = this.props.defaultValue;
    var value = this.props.defaultValue ? this.props.defaultValue : '';
    this.setState({ show: false, value: value, options: options });
  }
  select = (value,e) => {
    console.log(value);
    console.log(e.target.parent);
    console.log('change_xx');
    document.getElementById(this.props.id).value = value;
    if(typeof this.props.onChange === 'function'){
        this.props.onChange(document.getElementById(this.props.id).value, e);
    }

  }
  show =(e) => {
    this.setState({show:"show"});
    this.value = this.state.value;
  }
  hide =(e) => {
    window.setTimeout(() => {
        this.setState({show:''});
    }, 100);
    if(this.value !== this.state.value){
        console.log('change');
        document.getElementById(this.props.id).value = e.target.value;
        if(typeof this.props.onChange === 'function'){
            this.props.onChange(this.state.value, e);
        }
    }
  }
  clear = () => {
        this.setState({show:'',value:''});

  }
  render() {
    var options = [];
    if(this.props.options){
      this.props.options.forEach(opt => {
          if(options.indexOf(opt.name) === -1){
            options.push(opt.name);
          }
      });
    }
    var i = 0;
    var dropdown =options.map((opt) => {
        if(this.state.value && this.state.value != null && opt && opt.toLowerCase().indexOf(this.state.value.toLowerCase()) !== -1 && i < 10){
                i++;
          return (
                <div onClick={this.select.bind(this,opt)} className="option">{opt}</div>
          )
        }
        return null;
    });
    dropdown = dropdown ? <div className="dropdown">{dropdown}</div> : '';
    return (
      <div className={'ComboBox ' + this.state.show} >
          <input id={this.props.id} defaultValue={this.props.defaultValue} onChange={this.handle} onFocus={this.show} onBlur={this.hide}  />
          <button onClick={this.clear}><i className="material-icons">close</i></button>
          {dropdown}
      </div>
    );
  }
}

export default ComboBox;



// WEBPACK FOOTER //
// ./src/ComboBox.js